import React from "react";
import { Form, Formik, Field } from "formik";
import { ApiService } from "../../../../../services/ApiService";

export default function RejectModal({
  closeModal,
  rejectRequest,
  alert,
  request,
  rejectManyRequest,
  rejectManyState,
  rejectRequests
}) {
  
  return (
    <React.Fragment>
      <h4 style={{ color: "#000" }}>Reject office asset</h4>
      <Formik
        initialValues={{
          reason_for_rejection: "",
        }}
        onSubmit={(values, { setSubmitting }) => {
          // ApiService.post("requests/reject-request", values).then((res) => {
          //   if (res.data.type === false) {
          //     alert.error(res.data.msg);
          //   } else if (res.data.type === true) {
          //     alert.success(res.data.msg);
          //   }
          //   // getRequest();
          //   closeModal();
          // });
          closeModal();
          rejectRequests(request, values.reason_for_rejection);
          // rejectManyRequest(rejectManyState, values.reason_for_rejection)
        }}
      >
        {({ handleSubmit, values, isSubmitting }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="form-group">
                  <label>
                    Reason for rejection{" "}
                    <span className="text-danger"> * </span>
                  </label>
                  <Field
                    name="reason_for_rejection"
                    as="textarea"
                    required="required"
                    cols="10"
                    rows="5"
                    className="form-control"
                  ></Field>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <div className="col">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
              <div className="col-md-10">
                <button
                  type="submit"
                  className="btn btn-block nt-button-color-default btn-sm"
                >
                  Save{" "}
                  {isSubmitting ? (
                    <span
                      id="login_spinner"
                      className="fa fa-spin fa-spinner"
                    ></span>
                  ) : null}
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/container/dashboard/organizationmanagement/request/modal/reject.js